module.exports = __webpack_public_path__ + "assets/img/listStyle.ed52cf54.svg";